import React from "react";
import { CheckCircle2, AlertTriangle, Link2 } from "lucide-react";
import { InfoPanel } from "./fields";
import { Button } from "../ui/button";
import { AppointmentBooking } from "./AppointmentBooking";
import { INTAKE } from "../../constants/testIds";

const fmtDate = (iso) => {
  if (!iso) return "the date provided";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch (e) {
    return iso;
  }
};

export const Confirmation = ({ result, form, config }) => {
  const route = result?.route;
  const urgent = result?.urgent;

  let body = "Thank you. We have received your enquiry. This is not confirmation that we can assist with your case or that a barrister has been booked.";
  if (route === "A") {
    body = `Thank you. We have received your enquiry concerning the hearing on ${fmtDate(form?.routeA?.hearing_date)}. This is not confirmation that a barrister has been booked.`;
  } else if (route === "D") {
    body = `Thank you. We have received your enquiry about challenging the decision made on ${fmtDate(form?.routeD?.decision_date)}. This does not confirm that we can assist you, that an appeal will be filed or that a barrister has been booked. We must first consider the information and documents provided, any applicable deadline, conflicts, availability and fees. Submitting this form does not extend an appeal deadline, suspend the existing order or prevent enforcement.`;
  }

  return (
    <div className="space-y-6 text-center max-w-2xl mx-auto py-6" data-testid={INTAKE.confirmation}>
      <CheckCircle2 className="h-14 w-14 text-brand-gold mx-auto" strokeWidth={1.25} />
      <h2 className="font-serif text-3xl text-brand-black">Enquiry received</h2>
      <p className="text-sm text-brand-darkgrey leading-relaxed">{body}</p>

      {urgent && (
        <InfoPanel tone="danger" testid="confirmation-urgent">
          <div className="flex items-start gap-2 text-left">
            <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 text-brand-danger" strokeWidth={1.5} />
            <div>
              <p className="font-medium">Your enquiry has been marked as urgent.</p>
              <p className="mt-1">{config?.response_target_text}</p>
              {result?.urgency_reasons?.length > 0 && (
                <ul className="mt-2 list-disc pl-5 text-xs">
                  {result.urgency_reasons.map((r) => <li key={r}>{r}</li>)}
                </ul>
              )}
            </div>
          </div>
        </InfoPanel>
      )}

      {result?.linked_enquiries?.length > 0 && (
        <div className="text-left border border-border bg-white p-4">
          <p className="text-sm font-semibold text-brand-black flex items-center gap-2 mb-2">
            <Link2 className="h-4 w-4 text-brand-gold" strokeWidth={1.5} /> Linked enquiries created
          </p>
          <ul className="space-y-1 text-sm text-brand-darkgrey">
            {result.linked_enquiries.map((l) => (
              <li key={l.id}>• {String(l.label || "").replace(/\s*\(Route [A-D]\)/i, "")}</li>
            ))}
          </ul>
        </div>
      )}

      {result?.id && <AppointmentBooking enquiryId={result.id} />}

      <p className="text-xs text-muted-foreground">
        A confirmation has been sent to the email address you provided.
      </p>
      <Button onClick={() => window.location.assign("/")} className="bg-brand-black text-white hover:bg-brand-gold rounded-sm" data-testid="confirmation-done">
        Finish
      </Button>
    </div>
  );
};
